import { apiService } from '@/services/APIService';
import { CRUDFactory } from '../CRUDFactory';

export const CRUDUsers = CRUDFactory('users');

export default {

  publicUsers(params) {
    return apiService.get('/public/users', params);
  },

  userMe(params) {
    return apiService.get('/users/me', params);
  },

  updateProfile(id, params) {
    return apiService.put(`/profile/${id}`, params);
  },

  updatePassword(id, params) {
    return apiService.put(`/users/${id}`, params);
  },

  roles() {
    return apiService.getCached('/role');
  },

  // Блокировка пользователя в системе
  block(id) {
    return apiService.post(`/users/${id}/block`);
  },

  // Разблокировка пользователя в системе
  unblock(id) {
    return apiService.post(`/users/${id}/block`);
  },
  changeUser(id, params) {
    return apiService.post(`/client-questions/${id}/change-user`, params);
  },
};
